// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddressCard_wrapper__3X1wi","content":"AddressCard_content__1fckF"};